class DetailsDisclosure extends HTMLElement {
  constructor() {
    super()
    this.mainDetailsToggle = this.querySelector('details')

    this.addEventListener('keyup', window.onKeyUpEscape)
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this))
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close()
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open')
  }
}

customElements.define('details-disclosure', DetailsDisclosure)

const toggleSubMenu = elem => {
  elem.preventDefault()
  const menuItem = elem.currentTarget
  const menuItemHandle = menuItem.getAttribute('data-submenu-handle')
  const targetSubMenu = document.querySelector(`.header__submenu-nav[data-parent-handle=${menuItemHandle}]`)

  if (targetSubMenu.hasAttribute('open')) {
    targetSubMenu.removeAttribute('open')
  } else {
    targetSubMenu.setAttribute('open', '')
  }
}

document.querySelectorAll('.header__menu-dropdown').forEach(elem => {
  elem.addEventListener('click', toggleSubMenu)
})
